import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CategoryPage.css";

const CategoryPage = () => {
  const navigate = useNavigate();
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Ladezustand
  const [timeoutReached, setTimeoutReached] = useState(false); // Timeout für die Ladeanzeige

  useEffect(() => {
    fetchCategoryData();

    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 5000); // 5 Sekunden Timeout

    return () => clearTimeout(timer);
  }, [category]);

  // Scroll to top whenever the category changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [category]);

  const fetchCategoryData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${category}` // Backend-API für Produkte einer Kategorie
      );
      const data = await response.json();

      // Nur nicht-archivierte Produkte filtern
      const nonArchivedProducts = data.filter((product) => !product.archiviert);

      const sortedProducts = nonArchivedProducts.sort((a, b) => {
        if (a.title === "Kopf wechseln") return 1;
        if (b.title === "Kopf wechseln") return -1;
        return a.title.localeCompare(b.title);
      });
      setProducts(sortedProducts);
      setLoading(false); // Laden abgeschlossen
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false); // Fehler beendet den Ladezustand
    }
  };

  // Dynamisch vorhandene Inhaltsstoffe ermitteln
  const ingredientMapping = {
    "1": "1 mit Farbstoff",
    "2": "2 mit Taurin",
    "3": "3 mit Antioxidationsmittel",
    "4": "4 Chininhaltig",
    "5": "5 mit Koffein",
  };

  const availableIngredients = Object.keys(ingredientMapping).filter((key) =>
    products.some(
      (product) =>
        product.inhaltstoffe && product.inhaltstoffe.includes(key)
    )
  );

  return (
    <div className="category-page-container">
      <div className="content12">
        <h2 className="selected-category-title">{category}</h2>
        <div className="product-list-container">
          {loading ? (
            <p className="loading-text">Ladet...</p>
          ) : products.length > 0 ? (
            products.map((product, index) => (
              <div
                className="product-item-card fade-in-animation"
                key={index}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="product-item-content">
                  <p className="product-item-title">{product.title}</p>
                  <div className="product-item-details">
                    <span className="product-item-quantity">{product.menge}</span>
                    <span className="product-item-price">{product.preis}€</span>
                  </div>
                  {product.inhaltstoffe && product.inhaltstoffe.trim() !== "" && (
                    <p className="product-item-ingredients">
                      Inhaltsstoffe: {product.inhaltstoffe}
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : timeoutReached ? (
            <p className="no-products">Keine Produkte in dieser Kategorie verfügbar.</p>
          ) : (
            <p className="loading-text">Ladet...</p>
          )}
        </div>
        <br />
        <br />

        {availableIngredients.length > 0 && (
          <div className="ingredients">
            <p>Inhaltsstoffe:</p>
            <p>
              {availableIngredients.map((key) => ingredientMapping[key]).join(", ")}
            </p>
          </div>
        )}

        <button
          className="back-button"
          onClick={() => {
            navigate(-1);
            window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top on back button click
          }}
        >
          Zurück zur Kategorienliste
        </button>
      </div>
    </div>
  );
};

export default CategoryPage;
